import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { AngularMaterialModule } from 'src/app/angular-material.module';
import { FrontFirstPermissionTreeComponent } from './front-first-permission-tree.component';

/**
 * Árvore de permissões "Por tela" (front-first) — portada do abcx-web
 * (`shared/components/front-first-permission-tree`, staging 70989884). Sem a dependência de
 * `MenuNavSearchSource`/`SpinnerModule` do ABCX: o wazir-api já entrega o `pathLabel`.
 */
@NgModule({
  declarations: [FrontFirstPermissionTreeComponent],
  imports: [CommonModule, FormsModule, AngularMaterialModule, FlexLayoutModule],
  exports: [FrontFirstPermissionTreeComponent],
})
export class FrontFirstPermissionTreeModule {}
